import { useGetMeetingRecordings } from '@actions';
import Button from '@components/V4/Button';
import { useAuthState } from '@contexts/AuthContext';
import { UserRole } from '@shared/enums';
import { useState } from 'react';
import MeetingDetail from './MeetingDetail';

interface MeetingRecordingsProps {
  meetingId: string;
}

const MeetingRecordings = ({ meetingId }: MeetingRecordingsProps) => {
  const { roles } = useAuthState();
  const [isRequested, setIsRequested] = useState(false);

  const isFinancial = roles.includes(UserRole.Financial);

  const { data, isLoading, isError } = useGetMeetingRecordings(meetingId, {
    enabled: isRequested && isFinancial,
    cacheTime: 0,
    staleTime: 0,
  });

  if (!isFinancial) return null;

  const renderValue = () => {
    if (!isRequested) {
      return (
        <Button
          variant="text"
          buttonText="Show recording"
          onClick={() => setIsRequested(true)}
          className="h-auto"
        />
      );
    }

    if (isLoading) return <span className="text-customGrey">Loading...</span>;

    if (isError) return <span className="text-customRed">Could not load the recording.</span>;

    if (!data?.recordings?.length) {
      return <span className="text-customGrey">No recording stored.</span>;
    }

    return (
      <span className="flex flex-col gap-1">
        {data.recordings.map((recording) => (
          <a
            key={recording.url}
            href={recording.url}
            target="_blank"
            rel="noreferrer"
            className="text-customPrimary underline hover:text-customPrimary"
          >
            {recording.recordingType.replaceAll('_', ' ')}
          </a>
        ))}
        <span className="text-customGrey">
          {`Links expire in ${Math.round((data.expiresInSeconds ?? 0) / 60)} minutes.`}
        </span>
      </span>
    );
  };

  return <MeetingDetail name="Recording:" value={renderValue()} />;
};

export default MeetingRecordings;
